@if (greenPass) {
  <section class="route-selector" dir="rtl" aria-labelledby="route-heading">
    <div class="route-intro">
      <span class="route-intro__icon" aria-hidden="true">
        <svg width="23" height="23" viewBox="0 0 24 24"><path d="M12 3l2.1 4.25 4.7.68-3.4 3.31.8 4.68L12 13.7l-4.2 2.22.8-4.68-3.4-3.31 4.7-.68L12 3z"/></svg>
      </span>
      <div>
        <h2 id="route-heading">בחרו את המסלול שמתאים לכם</h2>
        <p>אפשר לפרסם בחינם או להגדיל את החשיפה עם מסלול מקודם.</p>
      </div>
    </div>

    @if (!termsAccepted) {
      <div class="route-error route-terms-required" role="status">
        {{ termsRequiredMessage }}
        <a href="#" class="route-terms-link" (click)="approveTermsHere($event)">לקריאה ואישור התקנון</a>
      </div>
    }

    <!-- SCRUM-313 + 328 — coupon option FIRST (before the VIP panel and every
         regular plan), only when the user has a usable coupon. The user must
         pick one explicitly; nothing is consumed until the publish call. -->
    @if (hasCoupons) {
      <section class="coupon-option" aria-labelledby="coupon-option-title">
        <header class="plan-head plan-head--rec">
          <span class="plan-head__icon" aria-hidden="true">
            <svg viewBox="0 0 24 24"><path d="M20 12a2 2 0 0 1 2-2V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v3a2 2 0 0 1 0 4v3a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-3a2 2 0 0 1-2-2zM11 15h2v2h-2zm0-4h2v2h-2zm0-4h2v2h-2z"/></svg>
          </span>
          <h3 id="coupon-option-title" class="coupon-option__title">פרסום באמצעות קופון</h3>
          <span class="plan-badge plan-badge--free">ללא עלות</span>
        </header>

        <div class="coupon-option__body">
          <p class="coupon-option__lead">בחרו את הקופון שבאמצעותו תפורסם המודעה:</p>
          <div class="coupon-list" role="radiogroup" aria-labelledby="coupon-option-title">
            @for (c of eligibleCoupons; track c.redemption_id) {
              <label class="coupon-item" [class.coupon-item--selected]="selectedCouponId === c.redemption_id">
                <input type="radio" class="coupon-item__radio" name="coupon-pick"
                       [value]="c.redemption_id"
                       [checked]="selectedCouponId === c.redemption_id"
                       [disabled]="isSubmitting"
                       (change)="selectCoupon(c)">
                <span class="coupon-item__mark" aria-hidden="true"></span>
                <span class="coupon-item__content">
                  <span class="coupon-item__top">
                    <span class="coupon-item__name">{{ c.title }}</span>
                    @if (c.recommended) {
                      <span class="plan-badge plan-badge--rec">מומלץ</span>
                    }
                  </span>
                  <span class="coupon-item__meta">
                    <span class="plan-chip coupon-item__level">{{ c.ad_level_label }}</span>
                    <span class="coupon-item__fact">{{ c.remaining_text }}</span>
                    <span class="coupon-item__fact">{{ c.duration_text }}</span>
                    <span class="coupon-item__fact coupon-item__fact--muted">{{ c.expires_text }}</span>
                  </span>
                </span>
              </label>
            }
          </div>

          @if (couponError) {
            <div class="route-error coupon-option__error" role="alert">{{ couponError }}</div>
          }

          <button type="button" class="route-card__action coupon-option__action"
                  [disabled]="!selectedCoupon || isSubmitting || !termsAccepted"
                  (click)="publishWithCoupon(freeAdv)">
            @if (couponBusy) {
              <span class="route-spinner" aria-hidden="true"></span>
              מפרסמים את המודעה...
            } @else {
              פרסם באמצעות הקופון
            }
          </button>
          @if (!selectedCoupon) {
            <p class="coupon-option__hint">יש לבחור קופון כדי לפרסם באמצעותו. ניתן גם לבחור מסלול רגיל למטה.</p>
          }
        </div>
      </section>
    } @else if (couponError) {
      <div class="route-error" role="alert">{{ couponError }}</div>
    }

    <!-- SCRUM-86 — a live VIP publishes from quota. Everyone else,
         including a LAPSED subscriber, sees the picker unchanged. -->
    @if (isVip) {
      <div class="vip-panel" [class.vip-panel--limit]="!vipCanPublish">
        <h3 class="vip-panel__title">
          {{ vipCanPublish ? 'המסלול שלך פעיל' : 'הגעת למכסת המודעות' }}
        </h3>
        <p class="vip-panel__usage">
          {{ vipQuota?.plan_name ? vipQuota.plan_name + ' · ' : '' }}{{ vipUsageLine }}
        </p>
        @if (!vipCanPublish) {
          <p class="vip-panel__hint">מחקו או השהו מודעה קיימת, או שדרגו את המסלול כדי לפרסם עוד.</p>
        }
        @if (vipCanPublish) {
          <button type="button" class="vip-panel__btn" [disabled]="vipBusy || !termsAccepted" (click)="vipPublish(freeAdv)">
            {{ vipBusy ? 'מפרסם…' : 'המשך פרסום' }}
          </button>
        } @else {
          <button type="button" class="vip-panel__btn vip-panel__btn--upgrade" (click)="vipUpgrade()">
            שדרג מסלול
          </button>
        }
      </div>
    } @else {
    <div class="route-grid" role="list">
      @for (adsRoute of AdvFormService.adsRoutes | sortBy:'level'; track adsRoute.id) {
        <article
          class="route-card"
          role="listitem"
          [class.route-card--featured]="isRecommended(adsRoute)"
          [class.route-card--selected]="selectedLevel === adsRoute.level"
          [class.route-card--blocked]="isBlocked(adsRoute)">

          <!-- SCRUM-239: same look as the app's plan cards (icon, title and
               badge in a header bar, big price, "X days active" chip) instead
               of a large picture per plan. -->
          <header class="plan-head" [class.plan-head--rec]="isRecommended(adsRoute)">
            <span class="plan-head__icon" aria-hidden="true">
              @switch (adsRoute.level) {
                @case ('LEVEL1') {
                  <svg viewBox="0 0 24 24"><path d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27zm0-2.33-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 5.6l1.7 4.08 4.38.38-3.32 2.88 1 4.28L12 14.94z"/></svg>
                }
                @case ('LEVEL2') {
                  <svg viewBox="0 0 24 24"><path d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg>
                }
                @default {
                  <svg viewBox="0 0 24 24"><path d="M17 10.43V2H7v8.43c0 .35.18.68.49.86l4.18 2.51-.99 2.34-3.41.29 2.59 2.24L9.07 22 12 20.23 14.93 22l-.78-3.33 2.59-2.24-3.41-.29-.99-2.34 4.18-2.51c.3-.18.48-.5.48-.86zm-6 .64-2-1.2V4h2v7.07zm4-1.2-2 1.2V4h2v5.87z"/></svg>
                }
              }
            </span>
            <h3 class="plan-head__title">{{ adsRoute.title | translate }}</h3>
            @if (isRecommended(adsRoute)) {
              <span class="plan-badge plan-badge--rec">מומלץ</span>
            } @else if (isBlocked(adsRoute)) {
              <span class="plan-badge plan-badge--off">לא זמין</span>
            }
          </header>

          <div class="route-card__body">
            <div class="plan-price">
              @if (adsRoute.price > 0) {
                <strong>₪{{ adsRoute.price | number:'1.0-2' }}</strong>
                <small>/ פרסום</small>
              } @else {
                <strong class="plan-price--free">חינם</strong>
              }
            </div>

            <ul class="route-card__features">
              @for (line of adsDescription(adsRoute.description); track line) {
                <li>
                  <span aria-hidden="true">✓</span>
                  {{ line | translate }}
                </li>
              }
            </ul>

            @if (adsRoute.lifeSpan) {
              <div class="plan-meta">
                <span class="plan-chip">
                  <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M19 4h-1V2h-2v2H8V2H6v2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 16H5V10h14v10zm0-12H5V6h14v2z"/></svg>
                  {{ adsRoute.lifeSpan }} ימים פעיל
                </span>
              </div>
            }

            <hr class="plan-divider">

            <button
              type="button"
              class="route-card__action"
              [class.route-card__action--outline]="!isRecommended(adsRoute)"
              [disabled]="isBlocked(adsRoute) || isSubmitting || !termsAccepted"
              (click)="selectRoute(freeAdv, adsRoute)">
              @if (isSubmitting && selectedLevel === adsRoute.level) {
                <span class="route-spinner" aria-hidden="true"></span>
                מכינים את המודעה...
              } @else if (isBlocked(adsRoute)) {
                לא זמין כרגע
              } @else {
                בחר חבילה
                <span class="plan-arrow" aria-hidden="true">‹</span>
              }
            </button>
          </div>

          @if (isBlocked(adsRoute)) {
            <div class="route-card__notice" role="status">{{ dynamicMessage }}</div>
          }
        </article>
      }
    </div>
    }

    @if (submitError) {
      <div class="route-error" role="alert">{{ submitError }}</div>
    }

    <div class="route-security">
      <svg width="17" height="17" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2l8 3v6c0 5.05-3.41 9.74-8 11-4.59-1.26-8-5.95-8-11V5l8-3zm0 3.12L7 7v4c0 3.52 2.2 6.94 5 8.06 2.8-1.12 5-4.54 5-8.06V7l-5-1.88z"/></svg>
      תשלום מאובטח • ניתן לבחור מסלול אחד בלבד • המחיר מוצג מראש
    </div>
  </section>
}

<ng-template #freeAdv>
  <app-free-adv [dialogRef]="freeAdv"></app-free-adv>
</ng-template>
